// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"36b6a261","340":"5bef4fff","417":"aebe8446","448":"a11615d0","449":"507f5701","569":"00d237c0","592":"15d1caa1","663":"75c9a01d","715":"37e19215","739":"4d5a1f13","908":"855dcd92","965":"79994025"}[chunkId] + ".chunk.js";
};